
if(!window.customElements.get('cart-progress')) {
  class CartProgress extends HTMLElement {
    constructor() {
      super();
      this.thresholdOne = parseFloat(this.dataset.giftLimit);
      this.variantId = parseInt(this.dataset.variantId);
    }

    connectedCallback() {
      this.initGWP();
    }

    async initGWP() {
      this.cart = await this.getCartData();
      if (!this.cart) return;

      await this.testThreshold(this.cart);
    }

    async testThreshold(cart) {
      this.cartTotal = cart.total_price;
      this.giftInCart = cart.items.find((item) => item.variant_id === this.variantId);  
      let updates = this.setUpdates();

      if (Object.keys(updates).length === 0) {
        return;
      }
  
      await this.autoUpdateCart(updates);
    }
    
    setUpdates() {
      let updates = {};
      console.log(this.giftInCart, this.cartTotal, this.thresholdOne)
      if(this.variantId) {
        if (this.cartTotal >= this.thresholdOne) {
          if (!this.giftInCart) {
            updates[this.variantId] = 1; // Add the gift if not already in the cart
          }
        } else if (this.giftInCart) {
          updates[this.variantId] = 0; // Remove the gift if below the threshold
        }
      }
  
      return updates;
    }

    autoUpdateCart(updates) {
      const cartComponent = document.querySelector('cart-notification') || document.querySelector('cart-drawer');

      const formData = new FormData();
      Object.entries(updates).forEach(([variantId, quantity]) => {
        formData.append(`updates[${variantId}]`, quantity);
      });

      if (cartComponent?.getSectionsToRender) {
        const sections = cartComponent.getSectionsToRender().map(s => s.id).filter(Boolean);
        if (sections.length) {
          formData.append('sections', sections.join(','));
          formData.append('sections_url', window.location.pathname);
          cartComponent.setActiveElement?.(document.activeElement);
        }
      }

      const config = {
        method: 'POST',
        headers: { 'X-Requested-With': 'XMLHttpRequest' },
        body: formData
      };

      let error = false;

      fetch(`${window.routes.cart_update_url}.js`, config)
        .then((response) => response.json())
        .then((data) => {
          if (data.status) {
            console.error('Cart update failed:', data.errors || data.description);
            error = true;
            return;
          }

          // Redirect if no cart drawer or notification
          if (!cartComponent) {
            window.location = window.routes.cart_url;
            return;
          }

           cartComponent.renderContents(data);
        })
        .catch((e) => {
          console.error('Cart update error:', e);
          error = true;
        })
        .finally(() => {
          // remove loader?
        });
    }

    async getCartData() {
      return fetch(`${window.routes.cart_url}.js`, {
        method: 'GET'
      })
      .then(response => {
        return response.json();
      })
      .catch((error) => {
        console.error('Error:', error);
        return false;
      });
    }
  };

  window.customElements.define('cart-progress', CartProgress);
}
